export const noop = () => {};
export const isClient = typeof window !== 'undefined';
export const isProduction = process.env.NODE_ENV === 'production';
